module.exports = __webpack_public_path__ + "img/SANDOS_logo_lg.png";